import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=8c9c808a"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports